import React from 'react';

const experiences = [
    {
        duration: 'JUN 2021 - PRESENT',
        position: 'Senior Frontend Developer',
        company: 'Mandrill Tech Sdn. Bhd.',
        location: 'Bangsar South, Kuala Lumpur',
        details: 'Develop enhancements or corrections to software according to approved designs and following industry best practices and company standards and quality procedures. Document design specifications for discussion with the Product Management team. Assist in gathering of user requirements from clients. Implement client projects within budgeted timeframes and costs.',
        techs: 'Angular, React.js, React Native, JSX/TSX, CSS/SCSS, Bootstrap, Angular Material, ngx-charts, JavaScript, TypeScript, ng-zorro, Strapi, Django, Java, Spring Boot, Figma'
    },
    {
        duration: 'JAN 2019 - PRESENT',
        position: 'Freelancing Developer',
        company: 'Freelancing',
        location: 'Wangsa Maju, Kuala Lumpur',
        details: 'Performed side project for other people and self-learning for improved skills.',
        techs: 'Angular, React.js, JSX, CSS/SCSS, Bootstrap, Angular Material, ngx-charts, JavaScript, TypeScript, ng-zorro, Strapi, Django, Figma, Firebase'
    },
    {
        duration: 'MAY 2020 - JUN 2021',
        position: 'Frontend Developer',
        company: 'Telekom Malaysia Research & Development',
        location: 'Cyberjaya, Selangor',
        details: 'Performed role as frontend website developer in various projects and providing a solution to the clients. Also execute development activities in web technologies in an integrated, timely, cost effective and high-quality manner in accordance with division\'s strategic and operating objectives.',
        techs: 'Angular 8, CSS Bootstrap, JavaScript, TypeScript, Adobe XD'
    },
    {
        duration: 'SEP 2017 - JAN 2020',
        position: 'Master of Philosophy Electrical Engineering',
        company: 'Universiti Teknologi Malaysia',
        location: 'Johor Bahru, Johor'
    },
    {
        duration: 'SEP 2017 - AUG 2019',
        position: 'Research Assistant',
        company: 'Electronic and Computer Engineering Dept., UTM',
        location: 'Johor Bahru, Johor',
        details: 'Design MOSFET using TCAD Tools simulation and carried out the device performance result in term of their reliability and endurance. Collect experimental data and conduct statistical analyses of data sets such as graphs and spreadsheets. Create presentation slides and posters for future researchers.',
        techs: 'Silvaco TCAD Tools simulation, MATLAB'
    },
    {
        duration: 'SEP 2014 - APR 2017',
        position: 'Bachelor of Science (Honour) Physics',
        company: 'Universiti Teknologi MARA',
        location: 'Jengka, Pahang'
    },
]




function Experience() {

    return (
        <div className="bg-exp" id="experience">
            <div className="max-exp">
                <h2><i>Experiences</i></h2>
                <div className="exp-map">
                    {experiences.map((exp) => (
                        <div style={{marginBottom: '40px'}}>
                            <p className='p1'><b>{exp.position}</b> - {exp.company}, {exp.location}</p>
                            <p className='p2'>{exp.duration}</p>
                            {exp.techs && <p className='p3'><b>Technologies: </b>{exp.techs}</p>}
                        </div>
                    ))}
                </div>
            </div>
        </div>  
    )
}

export default Experience
